// extracted by mini-css-extract-plugin
export default {"container":"LastMatchesResults_container__m79Dw","win":"LastMatchesResults_win__t8vhD","lose":"LastMatchesResults_lose__tpEnm","draw":"LastMatchesResults_draw__UnMfb"};